module.exports = __webpack_public_path__ + "img/iconfont.2c1992a0.svg";